import { reduxKey, EDITOR_DRAFT_EXPIRATION_DELTA } from './constants';
import { CompliantLocalStorageKeys } from '../../redux/compliantLocalStorage/constants';
import { getCompliantLocalStorageItem } from '../../redux/compliantLocalStorage/selectors';
import { isDumbChromeIOS } from '../../utils/browser';
function getEditorState(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey];
}
export function isAnyEditorFocused(state) {
    var editors = getEditorState(state);
    return Object.keys(editors).some(function (key) { return editors[key].isActive; });
}
export function isEditorFocused(state, editorKey) {
    var editors = getEditorState(state);
    return editors[editorKey] && editors[editorKey].isActive;
}
// Gets editor drafts json data from local storage and parses it
export function getEditorDraftsState(state) {
    if (typeof window === 'undefined') {
        return undefined;
    }
    return JSON.parse(getCompliantLocalStorageItem(state, CompliantLocalStorageKeys.EDITOR_DRAFTS) || '{}');
}
// Gets editor draft data for a specific editor key.
// If the draft is expired it returns undefined, otherwise it returns the initial content to be loaded by editor.
export function getEditorDraft(state, editorKey) {
    var allDrafts = getEditorDraftsState(state);
    var draftState = allDrafts && allDrafts[editorKey];
    var minUpdatedDate = Date.now() - EDITOR_DRAFT_EXPIRATION_DELTA;
    if (!draftState || draftState.updatedAt < minUpdatedDate) {
        return undefined;
    }
    return draftState.textContent;
}
export function getRequiresFallback(state) {
    if (isDumbChromeIOS()) {
        return false; // full editor for chrome ios
    }
    // We're checking window.visualViewport here because safari versions are wacky and this
    // api is supported in all the safari versions and other browsers we care about.
    if (typeof window !== 'undefined') {
        return !window.visualViewport;
    }
    return false;
}
//# sourceMappingURL=selectors.js.map